type InputConfigValueType = {
  icon: string,
  type: string,
  placeholder: string
};

type InputConfigType = {
  firstname: InputConfigValueType,
  email: InputConfigValueType,
  password: InputConfigValueType
};

export const inputConfig: InputConfigType = {
  firstname: {
    icon: 'IconUser',
    type: 'text',
    placeholder: 'registration.partials.firstname.placeholder'
  },
  email: {
    icon: 'IconEnvelopeSimple',
    type: 'email',
    placeholder: 'registration.partials.email.placeholder'
  },
  password: {
    icon: 'IconLock',
    type: 'password',
    placeholder: 'registration.partials.password.placeholder'
  }
};
